import React from 'react';

const ArrowDown = (props) => {

    return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={17} height={183}
    viewBox="0 0 17.5 183.5">
        <path fill={props.fill} d="M17.2,168.4c-0.3-0.5-0.8-0.7-1.3-0.7h-2.2c-0.5,0-1,0.3-1.3,0.8l-1.6,2.8V1.5c0-0.8-0.7-1.5-1.5-1.5h-2
    C6.5,0,5.8,0.7,5.8,1.5v168.7L5,168.5c-0.3-0.5-0.8-0.8-1.3-0.8H1.5c-0.5,0-1,0.3-1.3,0.7c-0.3,0.4-0.3,1-0.1,1.5l6.4,12.8
    c0.3,0.5,0.8,0.8,1.3,0.8h0.9c0.5,0,1-0.3,1.3-0.8l7.2-12.8C17.5,169.5,17.5,168.9,17.2,168.4z"/>
    </svg>

    )
};



export default ArrowDown


